import { render } from "./SearchForm.vue?vue&type=template&id=5fb1ffcc&scoped=true&ts=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=5fb1ffcc&lang=scss&scoped=true"

import exportComponent from "/Users/thibertletullier/Workspace/Digithia/app/internal/coprodex-color/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb1ffcc"]])

export default __exports__